import { render, staticRenderFns } from "./GuaranteesBlock.vue?vue&type=template&id=3adc800b"
import script from "./GuaranteesBlock.vue?vue&type=script&lang=js"
export * from "./GuaranteesBlock.vue?vue&type=script&lang=js"
import style0 from "./GuaranteesBlock.vue?vue&type=style&index=0&id=3adc800b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports